import { motion } from "framer-motion";
import { Crown, Sparkles, Star } from "lucide-react";

const steps = [
  {
    icon: Crown,
    title: "Choose Your Treasure",
    desc: "Select from our exclusive mystery scoop tiers — from The Duchess to The Queen.",
  },
  {
    icon: Sparkles,
    title: "Share Your Style",
    desc: "Tell us your favorite color, purse type, and designer preference to guide the magic.",
  },
  {
    icon: Star,
    title: "Watch the Reveal",
    desc: "The gong rings, your name is called, and the golden egg reveals your designer treasure!",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 md:py-32 relative"
    >
      <div className="absolute inset-0 section-glow-pink" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <p className="font-great-vibes text-[#FF007F] text-2xl md:text-3xl mb-4">
            The Royal Process
          </p>
          <h2 className="font-playfair text-[#D4AF37] text-4xl md:text-5xl font-bold">
            How It Works
          </h2>
          <div className="gold-line w-24 mx-auto mt-6" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              className="flex flex-col items-center text-center"
              data-testid={`step-${i + 1}`}
            >
              <div className="w-20 h-20 rounded-full border-2 border-[#D4AF37]/50 flex items-center justify-center mb-8 animate-pulse-gold">
                <step.icon
                  className="w-8 h-8 text-[#D4AF37]"
                  strokeWidth={1.5}
                />
              </div>
              <p className="text-[#D4AF37]/60 text-xs tracking-[0.3em] uppercase font-montserrat mb-3">
                Step {i + 1}
              </p>
              <h3 className="font-playfair text-white text-xl md:text-2xl mb-4">
                {step.title}
              </h3>
              <p className="font-montserrat text-white/40 text-sm leading-relaxed max-w-xs">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
